import sourceStore from "./sourceStore.js";
import sourceAdapterStore from "./sourceAdapterStore";
import sourceAdapterStateStore from "./sourceAdapterStateStore";
import sourceAdapterMessageStore from "./sourceAdapterMessageStore";
import transmissionStore from "./transmissionStore.js";
import realignRecordsStore from "./realignRecordsStore.js";
import meterStore from "./meterStore.js";
import tariffStore from "./tariffStore.js";
import tariffPeriodStore from "./tariffPeriodStore.js";
import meterUnitStore from "./meterUnitStore";
import ingestionStore from "./ingestionStore";
import visualizationStore from "./visualizationStore";
import incidentStore from "./incidentStore";
import groupStore from "./groupStore";
import groupContactStore from "./groupContactStore.js";
import meterUnitRecordStore from "./meterUnitRecordStore";
import meterUnitTariffStore from "./meterUnitTariffStore";
import tariffPlanStore from "./tariffPlanStore";
import ingestionTariffStore from "@/store/modules/project/metering/ingestionTariffStore";
export default {
  namespaced: true,
  modules: {
    sourceStore,
    sourceAdapterStore,
    sourceAdapterStateStore,
    sourceAdapterMessageStore,
    transmissionStore,
    meterStore,
    tariffStore,
    tariffPlanStore,
    meterUnitStore,
    ingestionStore,
    visualizationStore,
    incidentStore,
    groupStore,
    tariffPeriodStore,
    groupContactStore,
    meterUnitRecordStore,
    ingestionTariffStore,
    realignRecordsStore,
    meterUnitTariffStore
  }
};
